import React from 'react';
// import useCoupon from 'hooks/useCoupon';
import useCustomer from 'hooks/useCustomer';
import styles from './ContactButton.module.scss';

type CustomContactButtonProp = {
  url: string;
  text: string;
  emphasizedText: string;
};

const CustomContactButton: React.FC<CustomContactButtonProp> = ({ url, text, emphasizedText }) => (
  <a href={url} className={styles.contact} target='_blank' rel='noreferrer'>
    <span className={styles.contact__text}>{text}</span>
    <span className={`${styles.contact__text} ${styles.contact__text_emphasized}`}>{emphasizedText}</span>
  </a>
);

const ContactButton: React.FC = () => {
  // const { coupon } = useCoupon();
  const { isLetterCustomer } = useCustomer();

  // クーポンコードあり
  // if (coupon) {
  //   return (
  //     <CustomContactButton
  //       url={`https://docs.google.com/forms/d/e/1FAIpQLSeamgvUMXzKc_4p2SUWH17H7lUBc8vILfEwuRq_et8187dBbg/viewform?entry.1173614206=${coupon}`}
  //       text='乗り換え・追加割キャンペーン'
  //       emphasizedText='お申込みはこちら'
  //     />
  //   );
  // }
  // // トライアル申し込み
  // if (isTrialCustomer) {
  //   return (
  //     <CustomContactButton
  //       url='https://docs.google.com/forms/d/e/1FAIpQLSd1w8vf8zYb2zzduMjCJ15VJyEE723aCc1hqzYWjssWonil6Q/viewform'
  //       text='ホームぺージ無料トライアル'
  //       emphasizedText='お申込みはこちら'
  //     />
  //   );
  // }
  // // ラルマネのお問合せフォーム
  // if (isExistingCustomer) {
  //   return (
  //     <CustomContactButton
  //       url='https://rals-manager.jp/proposal/service/?svc=site07'
  //       text='ホームぺージに関する'
  //       emphasizedText='ご相談・お問合せ'
  //     />
  //   );
  // }
  // // 銀行等代理店経由のお問合せフォーム
  // if (isAgencyCustomer) {
  //   return (
  //     <CustomContactButton
  //       url='https://docs.google.com/forms/d/e/1FAIpQLSfb1U9O-xdrK-qnQqBOzCkcLI8tgTLgCxwDCLn4p0OazezT3w/viewform'
  //       text='ホームぺージに関する'
  //       emphasizedText='ご相談・お問合せ'
  //     />
  //   );
  // }
  // letterの場合
  if (isLetterCustomer) {
    return (
    <CustomContactButton
    url='https://rengotai.rals.co.jp/download_website-design?utm_source=ralsletter&utm_medium=other'
      text='ホームぺージに関する'
      emphasizedText='資料請求はこちら'
    />
    );
  }
  // FL専用資料請求フォーム（デフォルト）
  return (
    <CustomContactButton
    url='https://rengotai.rals.co.jp/download_website-design'
      text='ホームぺージに関する'
      emphasizedText='資料請求はこちら'
    />
  );
};

export default ContactButton;
